'use strict';

import axios from 'axios';
import getHeader from '../../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

async function isAdmin(token) {
	try {
		let response = await axios.post(API_URL + '/user/verifyAdmin', {}, await getHeader(token));

		return response.data;

	} catch(error) {
		return { error: error };
	}
}
    


export default isAdmin;
